export default function(component) {
  return () =>
    import(/* webpackChunkName: "[request]" */ `@/views/${component}.vue`)
}
